export default __webpack_public_path__ + "static/media/latest-editions-1.46671bd5.png";